// Suis `config/boost.open` — Boost dibuka kepada pelanggan? (PLAN_BOOST.md §🔄 2026-11-04)
// FAIL-CLOSED: belum log masuk / doc tiada / rules belum dideploy (permission-denied) / ralat → false.
// Dipakai App.jsx (route /boost) + StudioRail (menu Boost) — BERPASANGAN, buka serentak.
// ⚠️ Rules `match /config/boost { allow read: if request.auth != null; }` WAJIB dideploy, kalau
//    tidak pelanggan bukan-admin tidak boleh membaca doc ini → suis kekal mati untuk mereka (senyap).
// Admin menukar suis di /admin/boost (aksi server `adminBuka`), bukan dari sini.
import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

// Pulang: true (buka) · false (tutup / gagal baca) · null (sedang membaca — route dibiar wujud supaya
// pelanggan yang refresh /boost tidak ditendang sebelum jawapan tiba; SERVER tetap menolak bila suis
// mati — functions/boost.js `bukaUntukPelanggan`). Menu hanya dipapar bila === true.
export default function useBoostBuka(user) {
    // Hasil diikat pada uid — tukar akaun = "sedang membaca" semula tanpa setState segerak dalam effect.
    const [hasil, setHasil] = useState({ uid: null, buka: null });
    const uid = user?.uid || null;
    useEffect(() => {
        if (!uid) return undefined;
        return onSnapshot(
            doc(db, 'config', 'boost'),
            (snap) => setHasil({ uid, buka: snap.exists() && snap.data()?.open === true }),
            () => setHasil({ uid, buka: false }),
        );
    }, [uid]);
    if (!uid) return false;
    return hasil.uid === uid ? hasil.buka : null;
}
